export default __webpack_public_path__ + "static/media/cover2.cce5341d.JPG";